<template>
  
  <div id="app_content" class="public login">

    <div class="form">

      <div class="header">
        <img :src="logo">
      </div>

      <form>

        <div class="element">
          <label class="block w-100">Username</label>
          <input type="text" v-model="username">
          <span class="error">{{errors.username}}</span>
        </div>

        <div class="element"> 
          <label class="block w-100">Password</label>
          <v-password v-model="password"/>
          <span class="error">{{errors.password}}</span>
        </div>

        <v-checkbox :label="checkbox_label" v-model="remember_me" :selected="remember_me" />

        <button class="belt-btn animated" @click.prevent="validate()" 
          :class="{loading: loading}">
          Accedi
        </button>

      </form>

    </div>

  </div>

</template>

<script>
export default{

  data: function(){

    return {
      logo: window.location.origin + '/media/logo_4belt_black.png',
      username: '',
      password: '',
      remember_me: true,
      loading: false,
      errors: {
        username: '',
        password: ''
      },
      checkbox_label: 'Mantieni l\'accesso'
    }

  },

  methods: {

    validate: function(){

      if( !this.username || this.username == '' ){
        this.errors.username = 'Inserisci l\'username'
      } else{
        this.errors.username = ''
      }

      if( !this.password || this.password == '' ){
        this.errors.password = 'Inserisci la password'
      } else{
        this.errors.password = ''
      }

      if( this.errors.username == '' && this.errors.password == '' )
        this.login();

    },

    login: function(){

      var vue = this;
      vue.loading = true;

      axios({
        method: 'post',
        url: window.location.origin + '/data/auth',
        data: {
          username: vue.username,
          password: vue.password,
          remember_me: vue.remember_me
        }
      })
      .then(res => {

        if(res.data.url) window.location.href = res.data.url;

      })
      .catch(err => {

        vue.loading = false;
        
        vue.$store.commit('add_message', {
          type: 'error',
          message: err.response.data.message
        })

      })

    }

  }

  

}
</script>

<style scoped>
#app_content{
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--black);
}
.form{
  width: 95%;
  max-width: 600px;
  height: auto;
  margin: auto;
  padding: 4em;
  box-shadow: 1px 1px 1px gray;
  background-color: var(--background-gray);
}
.form .header{
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 2em;
}
.form .header img{
  width: 100%;
  max-width: 200px;
  height: auto;
}
div.element{
  margin-bottom: 1em;
}
div.element input{
  width: 100%;
  padding: 13px 20px;
  border: 1px solid gray;
}
span.error{
  color: var(--red);
  font-size: .9em;
}

</style>
